module.exports = __webpack_public_path__ + "img/default-song-image.951ee8b2.jpg";